import { Box, Skeleton, Stack, Typography, useColorScheme } from "@mui/material";
import BorderWidget from "./border_widget";
import { Constants } from "../../utils/constants";

export default function ProjectInfoWidget({
    title, des, value, icon, isLoading
}) {
    const { mode } = useColorScheme();
    return (
        <BorderWidget sx={{
            boxShadow: "0px 1px 3px 0px #0000001a",
        }}>
            <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"start"}
                spacing={2}
                sx={{
                    margin: "1.5rem 0",
                    padding: "1.5rem",
                }}
            >
                <Stack
                    spacing={1}
                >
                    {!isLoading ? <Typography
                        color={Constants.Colors.light.mutedForeground}
                        sx={{
                            fontSize: Constants.Styles.fontSize.sm,
                            lineHeight: Constants.Styles.lineHeight.sm,
                        }}
                    >
                        {title}
                    </Typography> : <Skeleton
                        variant={"text"}
                        width={100}
                        sx={{
                            fontSize: "1rem",
                        }}
                    />}
                    {!isLoading ? <Typography
                        sx={{
                            fontSize: Constants.Styles.fontSize["3xl"],
                            lineHeight: Constants.Styles.lineHeight["3xl"],
                            fontWeight: Constants.Styles.fontWeight.semiBold,
                        }}
                    >
                        {value}
                    </Typography> : <Skeleton
                        variant={"text"}
                        width={100}
                        sx={{
                            fontSize: "2rem",
                        }}
                    />}
                    {!isLoading ? <Typography
                        sx={{
                            fontSize: Constants.Styles.fontSize.xs,
                            lineHeight: Constants.Styles.lineHeight.xs,
                        }}
                    >
                        {des}
                    </Typography> : <Skeleton
                        variant={"text"}
                        width={"100%"}
                        sx={{
                            fontSize: "1rem",
                        }}
                    />}
                </Stack>
                <Box
                    sx={{
                        width: `calc(${Constants.Styles.spacing} * 10)`,
                        height: `calc(${Constants.Styles.spacing} * 10)`,
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: Constants.Colors[mode].secondary,
                    }}
                >
                    {!isLoading ? icon : <Skeleton
                        variant={"rounded"}
                        width={24}
                        height={24}
                    />}
                </Box>
            </Stack>

        </BorderWidget>
    );
}